module.exports = __webpack_public_path__ + "img/officeImg.bb4002ed.png";